// Author information

/** Profile image: put your photo at public/team/john-yaghobieh.jpg, or set to a full URL (e.g. LinkedIn CDN) */
export const AUTHOR = {
  name: 'John Yaghobieh',
  role: 'Main developer',
  bio: 'Building ForgeStack, Bear UI, and the ecosystem. Focus on developer experience and type safety across the stack.',
  imageUrl: 'https://media.licdn.com/dms/image/v2/C4D03AQEX-1AvyayRTw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1619541513083?e=1773273600&v=beta&t=Z27fqxOMIK_8Je-au3ZJKYliBopPasuWnYR2-AeDKvw',
  linkedin: 'https://www.linkedin.com/in/john-yaghobieh-4baa93107/',
  github: 'https://github.com/yaghobieh',
} as const;

export const CREATOR_TITLE = 'Creator of ForgeStack';
export const CREATOR_LINK_LABEL = 'Connect on LinkedIn';

export const SOCIAL_LINKS = {
  github: 'https://github.com/yaghobieh/ForgeStack',
  npm: 'https://www.npmjs.com/org/forgedevstack',
  /** Add your Discord invite URL here to enable the link */
  discord: '',
} as const;

